import clsx from 'clsx'

import s from './StateBlock.module.css'

interface StateBlockProps {
  kind: 'empty' | 'error'
  message: string
  onRetry?: () => void
}

export function StateBlock({ kind, message, onRetry }: StateBlockProps) {
  return (
    <div
      className={clsx(s.block, kind === 'error' && s.error)}
      role={kind === 'error' ? 'alert' : undefined}
    >
      <span>{message}</span>
      {onRetry && (
        <button type="button" className={s.retry} onClick={onRetry}>
          Повторить
        </button>
      )}
    </div>
  )
}
